export const flag_table_header = ({ viewCB }) => {
    return [
        {
            headerName: "Flag Type",
            width: 130,
            field: "flag_type",
            sortable: true,
            headerStyle: { textAlign: 'left', fontWeight: '600',},
        },
        {
            headerName: "Status",
            width: 120,
            field: "flag_status",
            sortable: true,
            renderCell: (params) => (
                <p style={{
                    padding: '2px 10px',
                    borderRadius: '12px',
                    fontSize: '13px',
                    fontWeight: 500,
                    textTransform: 'capitalize',
                    color: params.row.flag_status === 'pending' ? '#B45309' : '#065F46',
                    backgroundColor: params.row.flag_status === 'pending' ? '#FEF3C7' : '#D1FAE5',
                    display: 'inline-block',
                    width: 'fit-content'
                }}>
                    {params.row.flag_status}
                </p>
            )
        },
        {
            headerName: "Consultant",
            width: 150,
            field: "consultant_details.name",
            sortable: true,
            renderCell: (params) => <p>{params.row.consultant_details?.name || '-'}</p>
        },
        // {
        //     headerName: "User",
        //     width: 150,
        //     field: "user_details.name",
        //     sortable: true,
        //     renderCell: (params) => <p>{params.row.user_details?.name || '-'}</p>
        // },
        {
            headerName: "Reason",
            width: 220,
            field: "flag_reason",
            sortable: true,
            renderCell: (params) => (
                <p style={{
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: '200px'
                }} title={params.row.flag_reason}>
                    {params.row.flag_reason}
                </p>
            )
        },
        {
            headerName: "Feedback",
            width: 200,
            field: "feedback_details",
            sortable: false,
            renderCell: (params) => (
                <div style={{ fontSize: '14px', lineHeight: '18px' }}>
                    {params.row.feedback_details && (
                        <>
                            <div><strong>Rating:</strong> {params.row.feedback_details.rating}/5</div>
                            <p style={{
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                maxWidth: '180px'
                            }} title={params.row.feedback_details.review}>
                                {params.row.feedback_details.review}
                            </p>
                        </>
                    )}
                </div>
            )
        },
        {
            headerName: "Created At",
            width: 180,
            field: "createdAt",
            sortable: true,
            renderCell: (params) => (
                <p style={{ fontSize: '13px' }}>{new Date(params.row.createdAt).toLocaleString()}</p>
            )
        },
        {
            headerName: "Actions",
            width: 120,
            field: "actions",
            sortable: false,
            renderCell: (params) => (
                <div style={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'center'
                }}>
                    {params.row.flag_status === 'pending' && (params.row.flag_type === 'negative_feedback' || params.row.flag_type === 'refund_request') && (
                        <button
                            onClick={() => viewCB(params.row)}
                            style={{
                                padding: '6px 12px',
                                backgroundColor: '#2563EB',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '6px',
                                cursor: 'pointer',
                                fontSize: '13px',
                                fontWeight: 500
                            }}
                        >
                            View
                        </button>
                    )}
                </div>
            )
        }
    ];
};


export const user_table_header = ({
    walletCB,
    blockCB
}) => {
    return [
        {
            headerName: "Name",
            flex: 1,
            field: "name",
            sortable: true
        },
        {
            headerName: "Phone No.",
            type: "list",
            flex: 1,
            field: "details.phone",
            sortable: false,
            renderCell: (params) => <p>{params.row.details.phone}</p>
        }, {
            headerName: "Gender",
            type: "list",
            flex: 1,
            field: "details.gender",
            sortable: false,
            renderCell: (params) => <p className="capitalize">{params.row.details.gender}</p>
        }, {
            headerName: "Wallet Balance",
            flex: 1,
            field: "wallet",
            sortable: true
        }, {
            headerName: "DOB",
            type: "list",
            flex: 1,
            field: "details.dob",
            sortable: false,
            renderCell: (params) => {
                const birthDate = new Date(params.row.details.dob);
                const age = new Date().getFullYear() - birthDate.getFullYear();
                return <p className="capitalize">{birthDate.toLocaleDateString()} ({age}Yrs)</p>
            }
        },
        {
            headerName: "Actions",
            type: "list",
            flex: 1,
            field: "actions",
            sortable: false,
            renderCell: (params) => (
                <div className="flex gap-3 items-center justify-end">
                    <p
                        onClick={(_) => {
                            walletCB(params.row);
                        }}
                        className="underline border-blue-950 rounded-md font-bold text-blue-950 cursor-pointer"
                    >
                        Wallet
                    </p>
                    <p
                        onClick={(_) => {
                            blockCB(params.row);
                        }}
                        className="underline border-blue-950 rounded-md font-bold text-blue-950 cursor-pointer"
                    >
                        Block
                    </p>
                </div>
            ),
        },
    ];
};

export const waitlist_table_header = ({
    viewChatsCB, viewChatsLogsCB
}) => {
    return [
        {
            headerName: "User Name",
            width: 120,
            field: "request_form.firstName",
            sortable: true,
            renderCell: (params) => (
                <p>{`${params.row.request_form.firstName} ${params.row.request_form.lastName}`}</p>
            )
        },
        {
            headerName: "Phone",
            width: 120,
            field: "request_form.phoneNumber",
            sortable: true,
            renderCell: (params) => (
                <p>{params.row.request_form.phoneNumber}</p>
            )
        },
        {
            headerName: "Type",
            width: 120,
            field: "session_info.mode",
            sortable: true,
            renderCell: (params) => <div>
                <p className="capitalize">{params.row.session_info.mode}</p>
                <p className="capitalize">{params.row.used_for.replace(/_/g, ' ')}</p>
            </div>
        },
        {
            headerName: "Duration (sec)",
            width: 120,
            field: "requested_time",
            sortable: true,
            renderCell: (params) => (
                <p>{Math.round(params.row.requested_time / 60)} min</p>
            )
        },
        {
            headerName: "Status",
            width: 100,
            field: "status",
            sortable: true,
            renderCell: (params) => (
                <p className="capitalize">{params.row.status}</p>
            )
        },
        {
            headerName: "Created At",
            width: 160,
            field: "createdAt",
            sortable: true,
            renderCell: (params) => (
                <p>{new Date(params.row.createdAt).toLocaleString()}</p>
            )
        },
        {
            headerName: "Rate @time",
            width: 100,
            field: "session_info.price",
            sortable: true,
            renderCell: (params) => (
                <p>₹{params.row.session_info.price}</p>
            )
        }, {
            headerName: "Amounts",
            width: 200,
            field: "amounts",
            sortable: true,
            renderCell: (params) => <div style={{ fontSize: 10 }}>
                <p><span className="font-semibold">Consultant :</span> ₹{params.row.onCompletion?.consultantAmount}</p>
                <p><span className="font-semibold">Platform :</span> ₹{params.row.onCompletion?.platformAmount}</p>
                <p><span className="font-semibold">Is Refuned :</span> {params.row.onCompletion?.isAmountRefunded ? 'Yes' : 'No'}</p>
                <p><span className="font-semibold">Total :</span> ₹{params.row.onCompletion?.baseAmount}</p>
            </div>
        },
        {
            headerName: "Coupon",
            width: 120,
            field: "coupon.code",
            sortable: true,
            renderCell: (params) => <div style={{ fontSize: 10 }}>
                <p className="capitalize text-xs font-semibold">{params.row.coupon?.code || '-'}</p>
                <p className="capitalize text-xs font-semibold">{params.row.coupon?.description || '-'}</p>
            </div>
        },
        {
            headerName: "Actions",
            width: 200,
            field: "actions",
            sortable: true,
            renderCell: (params) => (
                <div className="flex gap-3 items-center justify-end">
                    <p
                        onClick={(_) => { viewChatsCB(params.row) }}
                        className="underline border-blue-950 rounded-md font-bold text-blue-950 cursor-pointer"
                    >
                        View Chats
                    </p>
                    <p
                        onClick={(_) => { viewChatsLogsCB(params.row) }}
                        className="underline border-blue-950 rounded-md font-bold text-blue-950 cursor-pointer"
                    >
                        View Logs
                    </p>
                </div>
            )
        }
    ];
};

export const consultant_table_header = ({
    chatWithAdminCB,
    fetchFlagLogs
}) => {
    return [
        {
            headerName: "Name",
            width: 180,
            field: "name",
            sortable: true
        },
        {
            headerName: "Phone No.",
            type: "list",
            width: 100,
            field: "details.phone",
            sortable: true,
            renderCell: (params) => <p>{params.row.details.phone}</p>
        },
        {
            headerName: "Is Active",
            width: 90,
            field: "isActive",
            sortable: true
        }, {
            headerName: "Session Status",
            type: "list",
            flex: 1,
            field: "sessionStatus",
            sortable: false,
            renderCell: (params) => <div>
                <p style={{ padding: '4px 8px 1px', fontSize: 10, margin: 2 }} className={`${!params.row.sessionsStatus.canGoOffline ? 'bg-slate-500' : 'bg-red-500 '} text-white inline-flex`}>Can Go Offline</p>
                <p style={{ padding: '4px 8px 1px', fontSize: 10, margin: 2 }} className={`${!params.row.sessionsStatus.isChatLive ? 'bg-slate-500' : 'bg-red-500 '} text-white inline-flex`}>Chat Call</p>
                <p style={{ padding: '4px 8px 1px', fontSize: 10, margin: 2 }} className={`${!params.row.sessionsStatus.isVoiceLive ? 'bg-slate-500' : 'bg-red-500 '} text-white inline-flex`}>Voice Call</p>
                <p style={{ padding: '4px 8px 1px', fontSize: 10, margin: 2 }} className={`${!params.row.sessionsStatus.isVideoLive ? 'bg-slate-500' : 'bg-red-500 '} text-white inline-flex`}>Video Call</p>
                <p style={{ padding: '4px 8px 1px', fontSize: 10, margin: 2 }} className={`${!params.row.sessionsStatus.isGoLive ? 'bg-slate-500' : 'bg-red-500 '} text-white inline-flex`}>Go Live</p>
            </div>
        }, {
            headerName: "Wallet",
            width: 100,
            field: "wallet",
            sortable: false
        }, {
            headerName: "Actions",
            width: 140,
            field: "admin_consultant_chat",
            sortable: true,
            renderCell: (params) => <div style={{ fontSize: 12 }} className="flex gap-3 items-center justify-end">
                <p className="underline border-blue-950 rounded-md font-bold text-blue-950 cursor-pointer" onClick={() => {
                    chatWithAdminCB(params.row);
                }}>Chat</p>
                <p className="underline border-blue-950 rounded-md font-bold text-blue-950 cursor-pointer" onClick={() => {
                    fetchFlagLogs(params.row);
                }}>Flag Logs</p>
            </div>
        }, {
            headerName: "Flags Limit",
            width: 100,
            field: "limit.flags.current",
            renderCell: (params) => <p>{params.row.limit.flags.current}/{params.row.limit.flags.max}</p>
        },
        {
            headerName: "Platform Share Rate",
            width: 120,
            field: "price.platformShare",
            renderCell: (params) => <p>{params.row.price.platformShare}%</p>
        }
    ];
};

export const coupon_table_header = [
    {
        headerName: "Coupon Code",
        flex: 1,
        field: "code",
        sortable: true
    }, {
        headerName: "Type",
        flex: 1,
        field: "type",
        sortable: true
    }, {
        headerName: "Value",
        flex: 1,
        field: "value",
        sortable: true
    }, {
        headerName: "Usage limit",
        flex: 1,
        field: "usageLimit",
        sortable: true
    }
]